import React, { Component } from "react";
import { Spectrophotometer } from "@learningblocks/storybook-components";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../../../Dialogs/toast/Toast";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";


const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: {
    title: "Microcentrifuge open or not balanced!",
    message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  },
  BALANCED: {
    title: "Balanced!",
    message: "Looks balanced."
  },
  NOT_BALANCED: {
    title: "Not balanced!",
    message: "Distribute the tubes evently to balance the centrifuge."
  },
  // WRONG_NUMBER_TUBES: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of tubes."
  // },
  // WRONG_NUMBER_ROTORS: {
  //   title: "Wrong number of tubes!",
  //   message: "Wrong number of rotors."
  // },
  NOT_ALLOWED_CENTRIFUGE_RUNNING: {
    title: "Centrifuge running!",
    message: "Operation not avaliable while centrifuge running."
  },
};

export class Graphics extends Component {

  removeCuvette = () => {
    this.props.setCuvettesInScene({
      id: this.props.cuvetteId,
      inScene: true
    });

    this.props.removeCuvette({
      id: this.props.id,
    });
  }


  render() {
    return (
      <Spectrophotometer
        id={this.props.id}
        notebookCollapsed={this.props.notebookCollapsed}
        lidOpen={this.props.lidOpen}
        poweredUp={this.props.poweredUp}
        wavelength={this.props.wavelength}
        relativeAbsorbance={this.props.relativeAbsorbance}
        absorbanceValue={this.props.absorbanceValue}
        cuvetteId={this.props.cuvetteId}
        solution={this.props.solution}
        alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
        showInfoModal={this.props.showInfoModal}
        showSettingsModal={this.props.showSettingsModal}
        questionTableCellUpdateResults={this.props.questionTableCellUpdateResults}
        absorbanceTableCellUpdate={this.props.absorbanceTableCellUpdate}
        absorbanceTable={this.props.absorbanceTable}
        toggleInfoModal={(props) =>
          this.props.toggleInfoModal({
            id: this.props.id,
            showInfoModal: props,
          })
        }
        toggleSettingsModal={(props) =>
          this.props.toggleSettingsModal({
            id: this.props.id,
            showSettingsModal: props,
          })
        }
        toggleLid={(props) =>
          this.props.toggleLid({
            id: this.props.id,
            isOpen: props,
          })
        }
        onClickPowerButton={(props) =>
          this.props.onClickPowerButton({
            id: this.props.id
          })
        }
        onClickZeroButton={(wavelength) => {
          this.props.onClickZeroButton({
            id: this.props.id
          })
        }}
        setWavelength={(wavelength) => this.props.setWavelength({
          id: this.props.id,
          wavelength: wavelength
        })}
        removeCuvette={() => this.removeCuvette()}
      />
    );
  }
}
